import React from "react";
import { useNavigate } from "react-router-dom";
import GuestReservationPanel from "../components/GuestReservationPanel";

export default function GuestReservationPage() {
  const navigate = useNavigate();
  return (
    <div className="page guest-reservation-screen">
      <h1 className="page-title">비회원 예약</h1>
      <GuestReservationPanel onGoLogin={() => navigate("/login")} />
    </div>
  );
}
